module.exports = __webpack_public_path__ + "static/media/Fuelgaugelevel.52848fd4.png";